import { Injectable } from '@angular/core';
import { RequestsServices } from './requests.service';

@Injectable()
export class ReportsService {

  constructor(private request: RequestsServices) { }

  getCompanyReports(params: string, limit = 1000): any {
    return this.request.get({ path: 'company_reports', pathParam: `/${params}?limit=${limit}&?filter[order]=date%20DESC` });
  }

  getMetabaseCompanyReport(companyId: string) {
    return this.request.get({ path: 'metabase_company_report', pathParam: `/${companyId}`});
  }

  getEstablishmentReports(companyId: string, limit = 12) {
    return this.request.get({ path: 'establishment_reports', pathParam: `/${companyId}?limit=${limit}`});
  }

  getPlacesMetrics(month, year, limit = 12) {
    return this.request.get({
      path: 'establishment_reports',
      endPoint: 'getPlacesMetrics',
      pathParam: `?month=${month}&year=${year}&limit=${limit}`
    });
  }

  getTopCompanies(companyId: string) {
    return this.request.get({ path: 'establishment_reports', endPoint: 'getTopCompanies', pathParam: `/${companyId}`});
  }

  getTopCategories(companyId: string, month: string, year: string) {
    return this.request.get({
      path: 'establishment_reports',
      endPoint: 'getTopCategories',
      pathParam: `/${companyId}?month=${month}&year=${year}`});
  }

  getTopPartners(companyId: string, month: string, year: string) {
    return this.request.get({
      path: 'establishment_reports',
      endPoint: 'getTopPartners',
      pathParam: `/${companyId}?&month=${month}&year=${year}`
    });
  }

}
